
import { config } from "config"
import { options } from "utils";

export const cambiarFilial = async (body) => {
    const url = `${config.URL_API_PRIVATE}/usuarios/filiales/cambiar`
    const response = await fetch(url, options("POST", body));
    const data = await response.json();
    return data;
};

/* export const seleccionarFilial = async (body) => {
    const url = `${config.URL_API_PRIVATE}/seleccionar/filial`
    const response = await fetch(url, options("POST", body));
    const data = await response.json();
    return data;
}; */